import Action from "../base/action";
import { ResourceTypeEnum } from "../base/training-literals";

class ResetModel extends Action {

    constructor(props) {
        super(props);
        this.models = props.models || [];
    }

    async execute({training}) {
        for (const data of this.models) {
            const modelId = training.resources[data.id].type === ResourceTypeEnum.HELPER_OBJECT
                ? data.id
                : training.resources[data.id].resourceId;
            AnimationPlayer.stopAllAnimationsOfThisModel(modelId);
            resetModelPositionAndRotation(modelId);
            await resetAllVolumePosRotOfThisModel(modelId);
            resetModelToExplosionMapIndividualFromServer(modelId);
            videoHotSpotFeature.removeAll360VideosForThisModel(modelId);
            imageHotSpotFeature.removeAll360ImagesForThisModel(modelId);
            wv.resetIndividualModelState(modelId);
        }
    }
}

export default ResetModel;
